import { useReadContract } from "wagmi";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import { DisplayValue, Typography } from "../../../../shared";
import { formatUnits } from "viem";

export const DisplayPriceTolerance: React.FC = () => {
  const { data: priceTolerance, ...rest } = useReadContract({
    abi: ArbitrageAbi,
    address: contractAddresses.Arbitrage,
    functionName: "priceTolerance",
  });

  return (
    <div className="flex flex-row gap-2">
      <Typography>Price Tolerance:</Typography>
      <DisplayValue
        viewValue={formatUnits(BigInt(priceTolerance || 0), 2)}
        {...rest}
      />
    </div>
  );
};
